<template>
  <div class="base">
    <account-header jump-user-type="teacher" />
    <div class="main">
      <div class="panel">
        <div>
          <div class="panno" />
        </div>
        <div class="title">
          <span>教员重置密码</span>
        </div>
        <div style="margin-top: 40px;text-align: left">
          <a-alert :message="'用户名：' + username" type="info" />
        </div>
        <div class="form-panel">
          <a-form :form="form" :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }" @submit="handleSubmit">
            <a-alert v-if="resetError" type="error" show-icon style="margin-bottom: 24px;"
              :message="resetErrorMessage" />
            <a-form-item>
              <a-input-password v-decorator="[
                'password',
                {
                  rules: [
                    {
                      validator: (rules, value, callback) => {
                        handleCheckPwd(rules, value, callback)
                      }
                    }
                  ],
                  validateTrigger: ['change', 'blur']
                }
              ]" size="large" placeholder="设置你的登录密码" autocomplete="new-password" />
            </a-form-item>
            <a-form-item>
              <a-input-password v-decorator="[
                'pwd_confirm',
                {
                  rules: [
                    {
                      validator: (rules, value, callback) => {
                        handleCfmPwd(rules, value, callback)
                      }
                    }
                  ],
                  validateTrigger: ['change', 'blur']
                }
              ]" size="large" placeholder="再次输入密码" autocomplete="false" :visibility-toggle="false" />
            </a-form-item>
            <a-form-item>
              <a-button size="large" type="primary" html-type="submit" block>
                确定
              </a-button>
            </a-form-item>
          </a-form>
        </div>
      </div>
    </div>
    <account-footer />
  </div>
</template>

<script>
import { AccountHeader, AccountFooter } from '@/components'

export default {
  name: 'TeacherResetPass',
  description: '这是描述信息',
  components: {
    AccountHeader,
    AccountFooter
  },
  props: {
    change_pass_token: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      formLayout: 'horizontal',
      form: this.$form.createForm(this, { name: 'coordinated' }),
      username: '',
      state: {
        resetBtn: false
      },
      resetError: false,
      resetErrorMessage: ''
    }
  },
  created() {
    if (this.change_pass_token === '') {
      this.$router.push({ path: '/' })
    }
    this.loadInfo(this.change_pass_token)
  },
  methods: {
    loadInfo(token) {
      this.$http({
        url: '/index/teacher_account/retrievePassPage',
        method: 'get',
        params: { change_pass_token: token }
      }).then(res => {
        if (res.status === 'success') {
          this.username = res.data.username
        } else {
          // 未获取到
          this.$toast.fail(res.message)
          setTimeout(() => {
            this.$router.push({ path: '/' })
          }, 3000)
        }
      })
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.state.resetBtn = true
          values.change_pass_token = this.change_pass_token
          this.$http({
            url: '/index/teacher_account/retrievePass',
            method: 'post',
            data: values
          })
            .then(res => {
              if (res.status === 'success') {
                this.$toast.success('重置密码成功，即将跳转登录页~')
                setTimeout(() => {
                  this.$router.push({ path: '/account/teacher-login' })
                }, 3000)
              } else {
                this.resetError = true
                this.resetErrorError = res.message
              }
            })
            .finally(() => {
              this.state.resetBtn = false
            })
        }
      })
    },
    handleCheckPwd(rules, value, callback) {
      if (value === undefined) {
        callback(new Error('请输入密码'))
      }
      var cfmPwd = this.form.getFieldValue('pwd_confirm')
      const PassWordRegex = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{8,20}$/
      if (!PassWordRegex.test(value)) {
        callback(new Error('密码至少包含字母和数字，并且长度在8~30'))
      }
      if (cfmPwd && cfmPwd !== value) {
        callback(new Error('两次密码输入不一致'))
      } else {
        // Note: 必须总是返回一个 callback，否则 validateFieldsAndScroll 无法响应
        callback()
      }
    },
    handleCfmPwd(rules, value, callback) {
      if (value === undefined) {
        callback(new Error('请再次输入你的密码'))
      }
      var password = this.form.getFieldValue('password')
      if (password && password !== value) {
        callback(new Error('两次密码输入不一致'))
      } else {
        // Note: 必须总是返回一个 callback，否则 validateFieldsAndScroll 无法响应
        callback()
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.base {
  min-width: 280px;
  max-width: 420px;
  margin: auto;
  background-color: #fff;
}

.main {
  padding: 15px;

  .panel {
    background-color: #ffffff;
    box-shadow: 1px 3px 16px 0px rgba(34, 23, 20, 0.1);
    border-radius: 10px;
    padding: 15px;
    overflow: hidden;
    margin-top: 15%;

    .panno {
      width: 75px;
      height: 10px;
      background-color: #fa750d;
      border-radius: 9px;
      position:relative;
      top:-18px;
      margin:auto;
    }

    .title {
      text-align:center;
      margin-top:8%;
      font-family: PingFang-SC-Bold;
      font-size: 18px;
      line-height: 21px;
      color: #333333;
      font-weight: bold;
    }
  }

  .form-panel {
    text-align: left;
    margin-top: 40px;
  }
}
</style>
